"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.normalizeDateMask = exports.getLocaleFromDocument = void 0;
var _replaceAll = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/replace-all"));
const getLocaleFromDocument = () => {
  return document.querySelector('html')?.getAttribute('lang') || 'en-us';
};

/**
 * Can be used like this: normalizeDateMask(window.GLOBAL_DATE_MASK)
 */
exports.getLocaleFromDocument = getLocaleFromDocument;
const normalizeDateMask = dateMask => {
  var _context, _context2, _context3, _context4;
  return (0, _replaceAll.default)(_context = (0, _replaceAll.default)(_context2 = (0, _replaceAll.default)(_context3 = (0, _replaceAll.default)(_context4 = dateMask || 'MM/dd/yyyy').call(_context4, 'm', 'M')).call(_context3, 'Mon', 'MMM')).call(_context2, 'D', 'd')).call(_context, 'Y', 'y');
};
exports.normalizeDateMask = normalizeDateMask;